import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import * as _ from 'lodash';
import { LANG_OPTIONS } from "../../lang.constants";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-email-sms-lang-modal',
  templateUrl: './email-sms-lang-modal.component.pug',
  styleUrls: ['./email-sms-lang-modal.component.scss'],
  standalone: false
})
export class EmailSmsLangModalComponent extends AbstractModalComponent implements OnInit {

  @Input() email_sms_langs!: string;
  @Input() model!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  newLang?: string;
  langOptions?: Map<string, string>;
  displayLangs: Array<any> = [];

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = this.model == 'exit' ? { 'email_sms_langs': this.email_sms_langs } : { 'pulse_email_sms_langs': this.email_sms_langs }
    this.resetLangOptions();
  }

  resetLangOptions() {
    this.langOptions = new Map();
    for (let [key, value] of LANG_OPTIONS) {
      if (this.model == 'exit') {
        if (!_.includes(this.orgDetails['email_sms_langs'], key)) {
          this.langOptions.set(key, value);
        }
      }
      else {
        if (!_.includes(this.orgDetails['pulse_email_sms_langs'], key)) {
          this.langOptions.set(key, value);
        }
      }
    }

    if (this.langOptions && this.langOptions.size > 0) {
      this.newLang = this.langOptions.entries().next().value?.[0];
    } else {
      this.newLang = '';
    }

    this.displayLangs = [];
    if (this.model == 'exit') {
      for (let email_sms_lang of this.orgDetails['email_sms_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }
    else {
      for (let email_sms_lang of this.orgDetails['pulse_email_sms_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }
  }

  add() {
    if (this.model == 'exit') {
      if (!_.includes(this.orgDetails['email_sms_langs'], this.newLang)) {
        this.orgDetails['email_sms_langs'].push(this.newLang);
      }
    }
    else {
      if (!_.includes(this.orgDetails['pulse_email_sms_langs'], this.newLang)) {
        this.orgDetails['pulse_email_sms_langs'].push(this.newLang);
      }
    }
    this.resetLangOptions();
  }

  delete(toDelete) {
    if (this.model == 'exit') {
      _.remove(this.orgDetails['email_sms_langs'], lang => lang === toDelete);

    }
    else {
      _.remove(this.orgDetails['pulse_email_sms_langs'], lang => lang === toDelete);
    }
    this.resetLangOptions();
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (this.orgForm.errors !== null || (this.orgDetails['email_sms_langs'] && this.orgDetails['email_sms_langs'].length === 0) || (this.orgDetails['pulse_emial_sms_langs'] && this.orgDetails['pulse_emial_sms_langs'].length == 0)) {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  reorder(event: CdkDragDrop<string[]>) {
    if (this.model == 'exit') {
      moveItemInArray(this.orgDetails['email_sms_langs'], event.previousIndex, event.currentIndex);
      this.displayLangs = [];
      for (let email_sms_lang of this.orgDetails['email_sms_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }
    else {
      moveItemInArray(this.orgDetails['pulse_email_sms_langs'], event.previousIndex, event.currentIndex);
      this.displayLangs = [];
      for (let email_sms_lang of this.orgDetails['pulse_email_sms_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }
  }

  getForm() {
    return this.orgForm;
  }

}
